var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBanner)?_c('div',{key:_vm.deal.id,staticClass:"banner",class:{'sold-out': _vm.isSoldOut,
           'coming-soon': _vm.isComingSoon,
           'is-ending': _vm.isEnding,
           'last-call': _vm.isLimitedTimeSale,
           'new-deal': _vm.isNewDeal,
  }},[(_vm.isLimitedTimeSale)?_c('span',{staticClass:"col-5 px-0"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@legacy/static/images/svg/as-plus-white.svg"),"width":"126","height":"12","alt":"Plus white icon"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"banner-text",class:{ 'limited-time-sale': _vm.isLimitedTimeSale },attrs:{"data-testid":"deal-banner-text"}},[_vm._v(_vm._s(_vm.bannerText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }